export default "__VITE_ASSET__ee4717c1__"